import { MouseEvent, ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import translation from '../../../../../languages';
import qualityEvents from '../../../../../services/quality-events/quality-events';
import isLinkToAnotherWorld from '../../../../../utils/is-link-to-another-world';
import getMaterialLink from '../../../../../utils/url/get-material-link';
import './cart-item-title.scss';

type CartItemTitleProps = TranslationProps & { item: Material; itemIndex: number };

const CartItemTitle = (props: CartItemTitleProps): ReactElement => {
    const { item, itemIndex, t } = props;

    const navigate = useNavigate();

    const materialPageUrl = getMaterialLink(item);

    const handleRedirectToMaterialPage = (): void =>
        isLinkToAnotherWorld(materialPageUrl)
            ? window.locationReload(materialPageUrl)
            : navigate(materialPageUrl, { state: { material: item } });

    const handleTitleClick = (event: MouseEvent): void => {
        event.preventDefault();
        qualityEvents.cartPage.clickMaterialFromCart({ item, itemIndex, onFinish: handleRedirectToMaterialPage });
    };

    return (
        <a
            href={materialPageUrl}
            className='cart-item-title'
            onClick={handleTitleClick}
            aria-label={t('materialPage.sections.previewsSlider.lookIntoMaterial')}
        >
            <h5>{item.title}</h5>
        </a>
    );
};

const translate = translation('material-page');

export default translate(CartItemTitle);
